import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";

import LoadingComponent from "../../app/layout/LoadingComponent";
import { getCATCursos } from '../../app/models/CATCursos';
import { Botonera } from '../Portafolio/helpers/botonera';
import { useStore } from "../../app/stores/store";

import { AnchorTabsCertificaciones } from "../Portafolio/Handlers/AnchorTabs";
import { BuscadorComponent } from "../Portafolio/BuscadorCursos/BuscadorComponent";
import { calculoFechas } from "../Portafolio/helpers/calculoFechas";

import banner from "../../images/Certificaciones.jpg";
import bannerCert from "../Portafolio/src/imgs/page_headers/certificaciones.png";
import Footer from "../Footer";

import icon_person from '../Portafolio/src/imgs/person_icon.svg';
import icon_teacher from '../Portafolio/src/imgs/teacher_icon.svg';
import icon_calendar from '../Portafolio/src/imgs/calendar_icon.svg';
import icon_location from '../Portafolio/src/imgs/pinpoint_icon.svg';

import { RegionalBannerCentral } from '../Portafolio/Handlers/RegionalBannerCentral';
import { AnchorTabsCategories } from "../Portafolio/Handlers/AnchorTabsCategories";
import { FiltroCardsCertificados } from "../Portafolio/Handlers/FiltroCursos";
import { nombreDelegacion } from '../Portafolio/helpers/nombreDelegacion';
import { Container } from "react-bootstrap";
import { myBreadCrumbs2L } from '../Portafolio/Handlers/Breadcrumbs';

export default observer(function Cursos() {

  const { userStore: { user, logout, isLoggedIn } } = useStore();
  const { CATCursosStore } = useStore();
  const { CATCursosRegistry, loadCATCursosByLevel, getCATCursosByLevel } = CATCursosStore;

  var levelRoot: string = "/";
  var parentCat: number = 0;
  var childLevel: number = 0;
  var levelActive: string = "certificaciones";

  useEffect(() => {
    if (CATCursosRegistry.size <= 1) {
      loadCATCursosByLevel("11", "1");
      loadCATCursosByLevel("12", "1");
      loadCATCursosByLevel("13"," 1");
      loadCATCursosByLevel("111", "2");
      loadCATCursosByLevel("122", "2");
      loadCATCursosByLevel("133", "2");
      loadCATCursosByLevel("1111", "4");
      loadCATCursosByLevel("1222", "4");
      loadCATCursosByLevel("1333", "4");
    }
    
  }, [CATCursosRegistry.size, loadCATCursosByLevel]);

  if (CATCursosStore.loadingInitial)

    return <LoadingComponent content="Cargando datos.." />;
  return (

    <>
      {/* <RegionalBannerCentral /> */}

      <div className="regional-head-area container-fluid">

        <div className="regional-title">
          <div className="regional-block-title"></div>
          <h3>INAP - Certificaciones</h3>
        </div>

      </div>
      <style>{`
        .regional-head-area {
          background-image: url(${bannerCert});
          background-size: cover;
          background-position: center top;
          background-repeat: no-repeat;
          width: 100%;
          position: relative;
          background-color: #f5f5f5;
        }

       
        @media (max-width: 549px) {
          .regional-head-area {
            height: 90px;
            background-size: contain;
          }
          .regional-title h3 {
            font-size: 16px;
          }
        }

        @media (min-width: 550px) and (max-width: 767px) {
          .regional-head-area {
            height: 130px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 18px;
          }
        }

        @media (min-width: 768px) and (max-width: 991px) {
          .regional-head-area {
            height: 170px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 20px;
          }
        }

        @media (min-width: 992px) and (max-width: 1199px) {
          .regional-head-area {
            height: 215px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 22px;
          }
        }

        @media (min-width: 1200px) and (max-width: 1990px) {
          .regional-head-area {
            height: 250px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 24px;
          }
        }

        @media (min-width: 1491px) {
          .regional-head-area {
            height: 260px;
            width: 100%;
          }
          .regional-title h3 {
            font-size: 26px;
          }
        }
      `}</style>

      <AnchorTabsCertificaciones />
      <AnchorTabsCategories />

      <div className="portafolio_phome_area catalogo_servicios">

        <div className="portafolio_header">
          {myBreadCrumbs2L("Certificaciones")}
          <Botonera />
          <FiltroCardsCertificados />

          <div className="buscador_area">
            <BuscadorComponent />
          </div>
        </div>

        <div id="section1" className="portafolio_htexto">
          <p>Las certificaciones son procesos estratégicos para generar valor público en las acciones que realizan las instituciones públicas, orientadas al fortalecimiento de la gestión institucional a través del desarrollo de las competencias del funcionario y servidor público, en función de la mejora de la prestación de los servicios destinados a la ciudadanía, reconocidos por la Oficina Nacional de Servicio Civil –ONSEC-. </p>
          </div>

        <div id="hw_search" className="portafolio_subcat first_section">
          <h2>Certificación Básica</h2>
        </div>

        <Container className="portafolio_subcat_desc">
          <p>Comprende conocimientos mínimos generales que un servidor público debe poseer para desempeñar su trabajo, en función del objetivo general que persigue la administración pública; permite la adquisición de conocimientos en dimensiones relacionadas a la Administración Pública, para que su incorporación al Sector Público se realice con mayor éxito en la búsqueda de la calidad y eficiencia.</p>
        </Container>

        <div id="hw_search" className="portafolio_content">

          {getCATCursosByLevel.map((item) => {
           

            const url = `/asesoria/${item.id}/${user?.id}`,
              startDateFrom = new Date(item.editions?.fechaDeInicioInscripcion);

            if (
              item.nivel == "11" && item.editions?.is_active === true ||
              item.nivel == "111" && item.editions?.is_active === true ||
              item.nivel == "1111" && item.editions?.is_active === true
            ) {
              return (

                
                  <div className="portafolio_card" id={item.nivel} key={item.id}> 
                    <Link to={url}>
                      <div className="pcard_imagen"> <img src={item.imageUrl} alt={item.nombre} /></div>
                      <div className="pcard_tipoc"> <p className="mod_card_basica">{item.modalidad}</p></div>
                      <div className="pcard_contenido_publico">
                        <div className="pcard_edicion">
                          <p>-Edición en curso {item.editions?.numeroEdicion}</p>
                        </div>
                        <div className="pcard_titulo_curso">
                          <p className='titulo_curso' id='titulo_curso'>{item.nombre}</p>
                        </div>
                        <div className="card_info_curso">
                          <div className="pcard_estudiantes">
                            <img src={icon_person} />
                            <p>Inicio de inscripciones</p>
                          </div>
                          <div className="pcard_fecha">
                            <img src={icon_calendar} />
                            <p> {calculoFechas(startDateFrom)} </p>
                          </div>
                        </div>

                        <div className="pcard_docentes">
                          <img src={icon_location} />
                          <p>Sede: {nombreDelegacion(item?.nivel)}</p>
                        </div>

                      </div>

                      <div className="pcard_linea"><span></span></div>

                    </Link>

                  </div>

                


              );
            }
          })}

        </div>

        <div id="section2" className="portafolio_subcat second_section">
          <h2>Certificación Intermedia</h2>
        </div>

        <Container className="portafolio_subcat_desc">
          <p>Enfocada en áreas de especialización en el Sector Público, que permiten al servidor público desarrollar competencias para desempeñar de mejor manera sus atribuciones; con ello se pretende conformar un cuerpo táctico y operativo eficiente para la toma de decisiones y operativización de los procesos institucionales que respondan a las demandas ciudadanas con relación a los servicios públicos.</p>
        </Container>

        <div id="hw_search" className="portafolio_content">

          {CATCursosStore.getCATCursosByLevel.map((item: getCATCursos) => {

            const url = `/asesoria/${item.id}/${user?.id}`,
              startDateFrom = new Date(item.editions?.fechaDeInicioInscripcion);

            if (
              item.nivel == "12" && item.editions?.is_active === true ||
              item.nivel == "122" && item.editions?.is_active === true ||
              item.nivel == "1222" && item.editions?.is_active === true
            ) {
              return (

                

                  <div className="portafolio_card" id={item.nivel} key={item.id}>

                    <Link to={url} >

                      <div className="pcard_imagen"> <img src={item.imageUrl} alt={item.nombre} /></div>
                      <div className="pcard_tipoc"> <p className="mod_card_intermedia">{item.modalidad}</p></div>

                      <div className="pcard_contenido_publico">
                        <div className="pcard_edicion">
                          <p>-Edición en curso {item.editions?.numeroEdicion}</p>
                        </div>

                        <div className="pcard_titulo_curso">
                          <p className='titulo_curso' id='titulo_curso'>{item.nombre}</p>
                        </div>

                        <div className="card_info_curso">
                          <div className="pcard_estudiantes">
                            <img src={icon_person} />
                            <p>Inicio de inscripciones</p>
                          </div>
                          <div className="pcard_fecha">
                            <img src={icon_calendar} />
                            <p> {calculoFechas(startDateFrom)} </p>
                          </div>
                        </div>

                        <div className="pcard_docentes">
                          <img src={icon_location} />
                          <p>Sede: {nombreDelegacion(item?.nivel)}</p>
                        </div>

                      </div>

                      <div className="pcard_linea"><span></span></div>

                    </Link>

                  </div>

                


              );
            }
          })}

        </div>

        <div id="section3" className="portafolio_subcat fourth_section">
          <h2>Certificación Avanzada</h2>
        </div>

        <Container className="portafolio_subcat_desc">
          <p>Desarrolla habilidades de liderazgo para la toma de decisiones en la alta gerencia pública, basadas en un pensamiento estratégico prospectivo.
        </p>
        </Container>

        <div className="portafolio_content">

          {CATCursosStore.getCATCursosByLevel.map((item: getCATCursos) => {

            const url = `/asesoria/${item.id}/${user?.id}`,
              startDateFrom = new Date(item.editions?.fechaDeInicioInscripcion);

            if (
              item.nivel == "13" && item.editions?.is_active === true ||
              item.nivel == "133" && item.editions?.is_active === true ||
              item.nivel == "1333" && item.editions?.is_active === true
            ) {
              return (

                

                  <div className="portafolio_card" id={item.nivel} key={item.id}>

                    <Link to={url} >

                      <div className="pcard_imagen"> <img src={item.imageUrl} alt={item.nombre} /></div>
                      <div className="pcard_tipoc"> <p className="mod_card_avanzada">{item.modalidad}</p></div>

                      <div className="pcard_contenido_publico">
                        <div className="pcard_edicion">
                          <p>-Edición en curso {item.editions?.numeroEdicion}</p>
                        </div>

                        <div className="pcard_titulo_curso">
                          <p className='titulo_curso' id='titulo_curso'>{item.nombre}</p>
                        </div>

                        <div className="card_info_curso">
                          <div className="pcard_estudiantes">
                            <img src={icon_person} />
                            <p>Inicio de inscripciones</p>
                          </div>
                          <div className="pcard_fecha">
                            <img src={icon_calendar} />
                            <p> {calculoFechas(startDateFrom)} </p>
                          </div>
                        </div>

                        <div className="pcard_docentes">
                          <img src={icon_location} />
                          <p>Sede: {nombreDelegacion(item?.nivel)}</p>
                        </div>

                      </div>

                      <div className="pcard_linea"><span></span></div>

                    </Link>

                  </div>

                


              );
            }
          })}

        </div>

      </div>

      <Footer />

    </>

  );
});
